<template>
<v-container>
    <!-- SEO goes here -->
</v-container>
</template>

<script>

// import { useMainStore } from '@/store/store';

export default {
    setup() {
        // const store = useMainStore()

        // return { store }
    },
    name: 'indexPage',
    
    components: {
        // VDateInput,
        // JsonCSV,
    },

    data: () => ({

    }),

    methods: {
        redirectToAbout(){
            this.$router.replace({ path: '/about' })
        }
    },
    mounted() {
        this.redirectToAbout()
    },

}
</script>

<style>

</style>